import Box from '@zenbusiness/zui/Box';
import Grid from '@zenbusiness/zui/Grid';
import Heading from '@zenbusiness/zui/Heading';
import PropTypes from 'prop-types';

import { validateRequiredField } from '#client/components/OpenAccountApplication/utils/validateRequiredFields';

import {
  GridStyled,
  IconAreaStyled,
  GreenCircle,
  TitleAreaStyled,
  ContentAreaStyled
} from './InfoCard.styles';

export const InfoCard = ({
  title,
  icon,
  data,
  invalidFields = [],
  leftFields = [
    {
      getReadOnlyField: () => {}
    }
  ],
  rightFields = [
    {
      getReadOnlyField: () => {}
    }
  ],
  ariaLabel
}) => (
  <GridStyled aria-label={ariaLabel}>
    <IconAreaStyled>
      <GreenCircle>{icon}</GreenCircle>
    </IconAreaStyled>
    <TitleAreaStyled>
      <Heading
        size="xl"
        weight="medium"
      >
        {title}
      </Heading>
    </TitleAreaStyled>
    <Box />
    <ContentAreaStyled>
      <Grid container>
        <Grid
          item
          md={6}
          xs={12}
        >
          {leftFields.map((field) => {
            const inValidData = validateRequiredField(invalidFields, field.getKey());

            return field.getReadOnlyField(data, inValidData);
          })}
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          {rightFields.map((field) => {
            const inValidData = validateRequiredField(invalidFields, field.getKey());
            return field.getReadOnlyField(data, inValidData);
          })}
        </Grid>
      </Grid>
    </ContentAreaStyled>
  </GridStyled>
);

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  data: PropTypes.shape().isRequired,
  invalidFields: PropTypes.arrayOf(PropTypes.string),
  leftFields: PropTypes.arrayOf(PropTypes.shape({ getReadOnlyField: PropTypes.func })),
  rightFields: PropTypes.arrayOf(PropTypes.shape({ getReadOnlyField: PropTypes.func })),
  ariaLabel: PropTypes.string
};
